import React from "react";
import CustomButton from "../../CustomControls/Buttons/CustomButton";
import { Row, Col, Card } from 'react-bootstrap';
import CustomBadge from "../../CustomControls/Badge/CustomBadge";
import { InAppImages } from "../../../Configurations/Constants";
import { CommandType } from "../../../Configurations/Constants";
import { FaBookmark } from "react-icons/fa";

const ScoreCard = (props) => {
  const {
    headerName,
    status = "success",
    statusName,
    userImage,
    username,
    professionalPosition,
    points,
    pointsLabel,
    acceptBtnName,
    declineBtnName,
    commonAction,
    infoBtnName,
    infoBtnAction,
    MATCHED,
    customClasses,
    matchedName,
    isManualMatching = false,
    acceptPayload,
    declinePayload,
    isSaved = false,
    onSave,
    saveBtnName = '♡ Save mentor',
    savedBtnName = '★ Mentor saved',
    showFavorite = false,
    children
  } = props;

  const handleCommonAction = (command) => {
    if (command === CommandType.Accept) {
      commonAction(command, acceptPayload);
    }
    else if (command === CommandType.Decline) {
      commonAction(command, declinePayload);
    }
  }

  const handleInfoBtnAction = () => {
    infoBtnAction();
  }

  return (
    <Col xs={12} md={6} lg={3} className={`w-321 score-card-wrapper ${customClasses || ""}`}>
      <div className="score-card-container">
        <Card className={`score-card-border score-card-full-height${showFavorite && isSaved ? ' score-card-saved' : ''}`}>
          <div className="flex h-63 bg-grey p-left-20 p-right-20">
            <div className=" occupy-1 start-center">
              <p className="p2-bold-v2">{headerName}</p>
            </div>
            <div className="end-center" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <CustomBadge type={status} labelName={statusName} />
              {showFavorite && isSaved && <FaBookmark className="save-bookmark-icon" />}
            </div>
          </div>
          <Card.Body className="p-top-0 score-card-body">
            <Row className="occupy-1">
              <Col className="occupy-1 column center-center">
                <div
                  style={{ width: "102px", height: "102px" }}
                  className="m-top-30 m-bottom-10">
                  <img
                    id="profileImg"
                    src={userImage || InAppImages.profileIcon}
                    className="rounded-circle img-objectfit"
                    style={{ width: "102px", height: "102px" }}
                    alt=""
                  />
                </div>
                <p className={`p-30 ${(username && username.length > 16) && "w-100-p"}`}>{username}</p>
                <p className="p3-medium m-top-5 m-bottom-10 professional-position-slot">{professionalPosition || " "}</p>
                {/* Matching score display hidden per UX CR
                {!isManualMatching &&
                <div className="m-top-33">
                  <div className="flex center-center score-card-text-border">
                    <p className="p-25-light  m-bottom-5">{points} <span className="p3-medium">{pointsLabel}</span></p>
                  </div>
                  <div className="flex center-center">
                    <p className="p3-medium m-top-8">Matching score</p>
                  </div>
                </div>
                }
                */}
                <CustomButton name={infoBtnName} onClickAction={handleInfoBtnAction} className="custom-btn-primary info w-max score-card-info-btn" />
              </Col>
            </Row>
          </Card.Body>
          {MATCHED && <div className="flex center-center w-max approve-label">
            <p>{matchedName}</p>
          </div>}
        </Card>
        {!MATCHED &&
          <div className="score-card-buttons">
            <CustomButton name={acceptBtnName} onClickAction={() => handleCommonAction(CommandType.Accept)} className="custom-btn-primary w-max"/>
            {showFavorite && (
              <CustomButton
                name={isSaved ? savedBtnName : saveBtnName}
                onClickAction={() => onSave && onSave()}
                className={`btn-save-mentor w-max${isSaved ? ' saved' : ''}`}
              />
            )}
            <CustomButton name={declineBtnName} onClickAction={() => handleCommonAction(CommandType.Decline)} className="custom-btn-not-right-fit w-max"/>
          </div>
        }
      </div>
      {children}
    </Col>
  );
}

export default ScoreCard;